import Nav from '@/components/Common/Nav/Nav';
import Logo from '@/components/Common/SideNav/Logo/Logo';
import {
  GET_WRAPPER_STYLES,
  getSideBarMenus,
} from '@/components/Common/SideNav/SideNav.utils';
import { useGlobalContext } from '@/context/Global/GlobalContext';
import Box from '@mui/material/Box';
import { VersionBadge } from '../VersionBadge/VersionBadge';
import { BottomMenu } from './BottomMenu/BottomMenu';

export function SideBarMenu() {
  const { session } = useGlobalContext();
  const links = getSideBarMenus(session);

  return (
    <nav>
      <Box data-testid="side-nav" sx={{ ...GET_WRAPPER_STYLES(false) }}>
        <Box sx={{ px: 2 }}>
          <Box sx={{ justifyItems: 'center' }}>
            <Logo collapse={false} />
            <VersionBadge />
          </Box>
          <Box sx={{ flexGrow: 1 }}>
            <Nav collapse={false} links={links} />
          </Box>
        </Box>
        <Box sx={{ flexGrow: 1, display: 'flex' }} />
        <BottomMenu />
      </Box>
    </nav>
  );
}
